'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    margin: 15px 0 0;\n  '], ['\n    margin: 15px 0 0;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRedux = require('react-redux');

var _colors = require('HubStyleTokens/colors');

var _FormattedCurrency = require('I18n/components/FormattedCurrency');

var _FormattedCurrency2 = _interopRequireDefault(_FormattedCurrency);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _UIExpandableSection = require('UIComponents/accordion/UIExpandableSection');

var _UIExpandableSection2 = _interopRequireDefault(_UIExpandableSection);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var QuestionContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Question__QuestionContainer'
})(['margin-top:15px;margin-left:25px;margin-right:30px;background-color:', ';', ''], _colors.OLAF, _responsiveBreakpoints2.default.phone(_templateObject));

var QuestionOutlineBorder = (0, _styledComponents2.default)(_UIExpandableSection2.default).withConfig({
  displayName: 'Question__QuestionOutlineBorder'
})(['border-width:0 0.5px 0.5px 1px;border-style:solid;border-color:', ';'], _colors.BATTLESHIP);

var Br = _styledComponents2.default.br.withConfig({
  displayName: 'Question__Br'
})(['line-height:40px;']);

var Question = function Question(_ref) {
  var questionKey = _ref.questionKey,
      href = _ref.href,
      currencyCode = _ref.currencyCode,
      pricingDependencies = _ref.pricingDependencies;

  var handleClickQuestion = function handleClickQuestion(question) {
    (0, _getUsageTracker2.default)().track('faqClickQuestionExpansion', {
      questionKey: question
    });
  };

  var handleClickLink = function handleClickLink() {
    (0, _getUsageTracker2.default)().track('externalLinkClick', {
      name: 'faq-click-link',
      url: href
    });
  };

  var getExtraOptions = function getExtraOptions(question) {
    var options = {};

    if (question === 'cms.cmsOnboarding') {
      options = {
        contentProfessionalOnboardingPrice: null,
        migrationFee: null
      };

      if (pricingDependencies.productData.products) {
        options.contentProfessionalOnboardingPrice = (0, _pricingUtils.calculatePriceAndItemConfig)(_extends({}, pricingDependencies, {
          merchandiseId: _MerchandiseIds.SERVICE_CONTENT_PROFESSIONAL_ONBOARDING
        })).oneTimeFee.calculatedPrice;

        options.migrationFee = (0, _pricingUtils.calculatePriceAndItemConfig)(_extends({}, pricingDependencies, {
          merchandiseId: _MerchandiseIds.SERVICE_FIRST_TIME_FULL_MIGRATION,
          additionalUnitQuantity: 21 // Needs to be 21 bc first 20 migrations are free
        })).oneTimeFee.calculatedPrice;
      }
    }

    return options;
  };

  return _react2.default.createElement(
    QuestionContainer,
    null,
    _react2.default.createElement(
      QuestionOutlineBorder,
      {
        titleText: _react2.default.createElement(_FormattedMessage2.default, {
          message: 'pricingPage.faq.' + questionKey + '.question'
        }),
        onClick: function onClick() {
          for (var _len = arguments.length, partialArgs = Array(_len), _key = 0; _key < _len; _key++) {
            partialArgs[_key] = arguments[_key];
          }

          return handleClickQuestion.apply(undefined, [questionKey].concat(partialArgs));
        }
      },
      _react2.default.createElement(_FormattedJSXMessage2.default, {
        message: 'pricingPage.faq.' + questionKey + '.answer_jsx',
        options: _extends({
          onClick: handleClickLink,
          href: href,
          currencyCode: currencyCode
        }, getExtraOptions(questionKey)),
        elements: { UILink: _UILink2.default, FormattedCurrency: _FormattedCurrency2.default, FormattedNumber: _FormattedNumber2.default, Br: Br }
      })
    )
  );
};

Question.propTypes = {
  questionKey: _react.PropTypes.string.isRequired,
  currencyCode: _react.PropTypes.string.isRequired,
  pricingDependencies: _react.PropTypes.object.isRequired,
  href: _react.PropTypes.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Question);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/Question.js
// module id = 172
// module chunks = 3 4